import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-course-create',
  templateUrl: './course-create.component.html',
  styleUrls: ['./course-create.component.scss']
})
export class CourseCreateComponent implements OnInit {

  checkClassHourMinValue: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {

    let miniAttendHours = group.get('miniAttendHours')?.value;
    if (miniAttendHours) {
      let classHours = group.get('classHours')?.value;
      return (Number(miniAttendHours) > classHours) ? { checkClassHoursMinValue: true } : null
    }
    return null;
  }

  checkClinicalHourMinValue: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    let miniLabHours = group.get('miniLabHours')?.value;
    if (miniLabHours) {
      let clinicalHours = group.get('clinicalHours')?.value;
      return (Number(miniLabHours) > clinicalHours) ? { checkClinicalHoursMinValue: true } : null
    }

    return null;
  }

  showLoader: boolean = false;
  creating: boolean = false;
  roles: any = [];
  orgs: any = [];
  coursesData: any;
  courses: any;
  CourseSelectedPreRequisite: any;
  CourseSelectedCoRequisite: any;
  dropdownSettings: any = {};
  ShowFilter = true;
  courseCategories:any = [];
  markGroups:any = [];


  // userInfo = {
  //   ISPID: 120105,
  //   Username: "Shady.abdallah@vodafone.com",
  //   Userstatus: "Activated",
  //   MobileNumber: "01002200020",
  //   UserType: "Internal",
  //   RoleType: "ISPAdmin",
  //   NationalID: "29502220112098"
  // }
  avaRoles: any;
  allIsps: any;

  createCourse = new FormGroup({
    subjectCode: new FormControl('', [
      Validators.required,
    ]),
    subjectNameEn: new FormControl('', [
      Validators.required,
      //Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.pattern('^[a-zA-Z0-9-_]([.](?![.])|[a-zA-Z0-9-_])*([@](?![@])|[a-zA-Z])([.](?![.])|[a-zA-Z])*[a-zA-Z]$'),
    ]),
    subjectNameAr: new FormControl('', [
      Validators.required,
      //Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.pattern('^[a-zA-Z0-9-_]([.](?![.])|[a-zA-Z0-9-_])*([@](?![@])|[a-zA-Z])([.](?![.])|[a-zA-Z])*[a-zA-Z]$'),
    ]),
    classHours: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    clinicalHours: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    totalHours: new FormControl(0, [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    creditHours: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    miniAttendHours: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    miniLabHours: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    fullDegree: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    passGrade: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    preRequisit: new FormControl('', [
    ]),
    coRequisit: new FormControl('', [
    ]),
    // note: new FormControl('', [
    // ]),
    category: new FormControl('', [
    ]),
    finalExamDuration: new FormControl('', [
    ]),
    final: new FormControl('', [
    ]),
    ongoing: new FormControl('', [
    ]),
    markGroup: new FormControl('', [
    ]),
  }, [this.checkClinicalHourMinValue, this.checkClassHourMinValue]);

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private coursesService: CoursesService
    , private roleService: RoleService
    , private orgService: OrgService
    , private academicsService: AcademicsService
  ) {

  }

  // changeRole(e: any) {
  //   this.createCourse.value.roleType = e.target.value, {
  //     onlySelf: true
  //   }
  // }
  ngOnInit(): void {
    this.getAciveCategoriesAndMarkGroupsAndCourses();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 24,
      allowSearchFilter: this.ShowFilter
    };

    // Test Data
    this.courseCategories = [
      {
        id: 1,
        nameAr: "test1 category ar",
        nameEn: "test1 category en",
      },
      {
        id: 2,
        nameAr: "test2 category ar",
        nameEn: "test2 category en",
      }
    ];

    this.markGroups = [
      {
        id: 1,
        nameAr: "test1 mark ar",
        nameEn: "test1 mark en",
      },
      {
        id: 2,
        nameAr: "test2 mark ar",
        nameEn: "test2 mark en",
      }
    ];
  }

  createCourseChange() {
    let classHours = this.createCourse.controls.classHours.value;
    let clinicalHours = this.createCourse.controls.clinicalHours.value;
    this.createCourse.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createCourseSubmit() {
    if (this.createCourse.valid) {
      // call your service 
      let subjectCode = this.createCourse.controls.subjectCode.value;
      let subjectNameAr = this.createCourse.controls.subjectNameAr.value;
      let subjectNameEn = this.createCourse.controls.subjectNameEn.value;
      let classHours = this.createCourse.controls.classHours.value;
      let practicalHours = this.createCourse.controls.clinicalHours.value;
      let creditHours = this.createCourse.controls.creditHours.value;
      let passDegree = this.createCourse.controls.passGrade.value;
      let minClassHours = this.createCourse.controls.miniAttendHours.value;
      let minPracticalHours = this.createCourse.controls.miniLabHours.value;
      let fullDegree = this.createCourse.controls.fullDegree.value;
      let category = this.createCourse.controls.category.value;
      let finalExamDuration = this.createCourse.controls.finalExamDuration.value;
      let final = this.createCourse.controls.final.value;
      let ongoing = this.createCourse.controls.ongoing.value;
      let markGroup = this.createCourse.controls.markGroup.value;
      
      this.addCourse(subjectCode, subjectNameAr, subjectNameEn, classHours, practicalHours,
        creditHours, passDegree, minClassHours
        , minPracticalHours, fullDegree, category, finalExamDuration, final, ongoing, markGroup)
    }
    else {
      this.createCourse.markAllAsTouched();
      this.createCourse.markAsDirty();
    }
  }

  addCourse(subjectCode: string, subjectNameAr: string, subjectNameEn: string, classHours: number, practicalHours: number, creditHours: number, passDegree: number, minClassHours: number, minPracticalHours: number, fullDegree: number, category: any, finalExamDuration: any, final: any, ongoing: any, markGroup: any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    let totalHours = Number(classHours) + Number(practicalHours);
    let examGradeTotal = Number(final) + Number(ongoing);

    this.coursesService.addCourse(username, 10, 30, subjectCode, subjectNameAr, subjectNameEn, classHours, practicalHours, totalHours, creditHours, passDegree, minClassHours, minPracticalHours, fullDegree, "YES", category, finalExamDuration, final, ongoing, examGradeTotal, markGroup)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            this.addPreCourses(data.id);
          } else {
            this.creating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }

  addPreCourses(CourseId: any) {
    if (this.CourseSelectedPreRequisite?.length > 0) {
      for (let i = 0; i < this.CourseSelectedPreRequisite.length; i++) {
        console.log(this.CourseSelectedPreRequisite[i].item_id)
        this.coursesService.addPreRequisetCourse(10, CourseId, this.CourseSelectedPreRequisite[i].item_id, "YES")
          .subscribe(
            data => {
              if (i == (this.CourseSelectedPreRequisite.length - 1)) {
                this.addCoCourses(CourseId);
              }
            },
            error => {
              this.creating = false;
              this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
            }
          );

      }
    } else if (this.CourseSelectedCoRequisite?.length > 0) {
      this.addCoCourses(CourseId);
    } else {
      this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
      this.router.navigate(['/enrolment/courses']);
      this.creating = false;
    }
  }

  addCoCourses(CourseId: any) {
    if (this.CourseSelectedCoRequisite?.length > 0) {
      for (let i = 0; i < this.CourseSelectedCoRequisite.length; i++) {
        console.log(this.CourseSelectedCoRequisite[i].item_id)
        this.coursesService.addCORequisetCourse(10, CourseId, this.CourseSelectedCoRequisite[i].item_id, "YES")
          .subscribe(
            data => {
              if (i == (this.CourseSelectedCoRequisite.length - 1)) {
                this.creating = false;
                this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
                this.router.navigate(['/enrolment/courses']);
              }
            },
            error => {
              this.creating = false;
              this.toastrService.warning(this.translate.instant('FAIL_TO_CREATE'));
            }
          );

      }
    } else {
      this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
      this.router.navigate(['/enrolment/courses']);
      this.creating = false;
    }


  }

  // getAllCourses() {
  //   this.showLoader = true;
  //   this.coursesService.getAllCourses().subscribe(
  //     data => {
  //       // this.courses = data;
  //       this.coursesData = data;
  //       this.courses = this.coursesData.map((course: any) => {
  //         return {
  //           item_id: course.id, item_text: course.subjectNameEn + " - " + course.subjectCode
  //         }
  //       });
  //       //   this.getAllOrgs();
  //       this.showLoader = false;
  //     },
  //     error => {
  //       this.toastrService.error(this.translate.instant("CAN_NOT_GET_ROLES"));
  //       this.showLoader = false;
  //     }
  //   );

  // }



  // addUserRole(userid: number, roleid: number, username: string
  //   // , orgid: number
  // ) {

  //   this.userService.addUserRole(userid, roleid, new Date(), new Date, "YES")
  //     .subscribe(
  //       data => {
  //         this.creating = false;
  //         this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
  //         this.router.navigate(['/users']);
  //         // this.addUserOrg(username, orgid, userid);
  //       },
  //       error => {
  //         this.creating = false;
  //         this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER_ROLE'));
  //       }
  //     );
  // }

  // addUserOrg(username: string, orgid: number, userid: number) {

  //   this.userService.addUserOrg(username, orgid, userid)
  //     .subscribe(
  //       data => {
  //         this.creating = false;
  //         this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
  //         this.router.navigate(['/users']);

  //       },
  //       error => {
  //         this.creating = false;
  //         this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_USER_ORG'));
  //       }
  //     );
  // }

  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  getAciveCategoriesAndMarkGroupsAndCourses(){
    this.showLoader = true;
    let bulkApis = [
      this.academicsService.getAllCourseCategory(),
      this.academicsService.getAllMarkGroup(),
      this.coursesService.getAllCourses()
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        // console.log(data);
        if(typeof data[0] != undefined)
          this.courseCategories = data[0];

        if(typeof data[1] != undefined)
          this.markGroups = data[1];

        if(typeof data[2] != undefined)
        {
          this.coursesData = data[2];
          this.courses = this.coursesData.map((course: any) => {
            return {
              item_id: course.id, item_text: course.subjectNameEn + " - " + course.subjectCode
            }
          });
        }
        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }

}
